import { useState, useEffect } from "react";

const navLinks = [
  { label: "Ana Sayfa", href: "#hero" },
  { label: "Hakkımızda", href: "#hakkimizda" },
  { label: "Menü", href: "#menu" },
  { label: "Galeri", href: "#galeri" },
  { label: "İletişim", href: "#iletisim" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? "bg-white/95 backdrop-blur-md border-b border-gray-100"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <button
          onClick={() => handleNavClick("#hero")}
          className="flex items-center gap-2.5 cursor-pointer"
        >
          <div className="w-7 h-7 flex items-center justify-center">
            <i className={`ri-anchor-line text-xl transition-colors duration-300 ${scrolled ? "text-[#1a3a4a]" : "text-white/90"}`}></i>
          </div>
          <span
            className={`font-semibold text-base tracking-widest uppercase transition-colors duration-300 ${scrolled ? "text-[#1a3a4a]" : "text-white"}`}
            style={{ fontFamily: "'Playfair Display', serif", letterSpacing: "0.12em" }}
          >
            Balıkçı Zafer
          </span>
        </button>

        {/* Desktop Nav — centered */}
        <ul className="hidden md:flex items-center gap-10 absolute left-1/2 -translate-x-1/2">
          {navLinks.map((link) => (
            <li key={link.label}>
              <button
                onClick={() => handleNavClick(link.href)}
                className={`text-xs font-medium tracking-widest uppercase transition-all duration-200 relative group cursor-pointer whitespace-nowrap ${
                  scrolled ? "text-[#1a3a4a]/80 hover:text-[#1a3a4a]" : "text-white/80 hover:text-white"
                }`}
              >
                {link.label}
                <span className="absolute -bottom-1 left-0 w-0 h-px bg-[#e8734a] transition-all duration-300 group-hover:w-full"></span>
              </button>
            </li>
          ))}
        </ul>

        {/* Right side — elegant phone link (scrolled only) */}
        <div className="hidden md:flex items-center gap-2">
          <a
            href="tel:+902320000000"
            className={`text-xs font-medium tracking-wide transition-all duration-300 flex items-center gap-1.5 whitespace-nowrap ${
              scrolled
                ? "text-[#e8734a] hover:text-[#d4623a]"
                : "text-white/0 pointer-events-none"
            }`}
          >
            <i className="ri-phone-line text-sm"></i>
            Rezervasyon
          </a>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`text-xl transition-colors duration-300 ${scrolled ? "text-[#1a3a4a]" : "text-white"} ${menuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-5 flex flex-col gap-3">
          {navLinks.map((link) => (
            <button
              key={link.label}
              onClick={() => handleNavClick(link.href)}
              className="text-[#1a3a4a] text-sm font-medium py-2 text-left cursor-pointer tracking-wide"
            >
              {link.label}
            </button>
          ))}
          <a
            href="tel:+902320000000"
            className="mt-2 flex items-center justify-center gap-2 border border-[#e8734a] text-[#e8734a] px-5 py-3 rounded-full text-sm font-semibold cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-line"></i>
            Rezervasyon Yap
          </a>
        </div>
      )}
    </nav>
  );
}
